// removed by extract-text-webpack-plugin
module.exports = {"title":"src-components-project-project-role----project-role-module---title---11z53","list":"src-components-project-project-role----project-role-module---list---3nc65","dash":"src-components-project-project-role----project-role-module---dash---yaXKA","item":"src-components-project-project-role----project-role-module---item---50kM1"};


//////////////////
// WEBPACK FOOTER
// ./src/components/project/project-role/project-role.module.css
// module id = 532
// module chunks = 140935043865547